import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", { d: "M13.7 4H2.3C1.585 4 1 4.554 1 5.228v7.544C1 13.455 1.586 14 2.3 14h11.4c.724 0 1.3-.554 1.3-1.228V5.228C15 4.545 14.414 4 13.7 4Zm-1.2 1.385L8.005 9.642 3.5 5.385h9Zm-10.034 7.23V6.364l4.612 4.358c.244.23.576.36.918.36.342 0 .674-.13.918-.36l4.621-4.358v6.251H2.465Z" }, null, -1), r = [
  n
];
function l(s, d) {
  return e(), t("svg", c, [...r]);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
